import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import AppBar from "@material-ui/core/AppBar";
import { Alert } from '@material-ui/lab';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import CloseIcon from '@material-ui/icons/Close';
import { useState, useEffect } from "react";
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Collapse,
  CustomInput,
  Card,
  ModalBody,
  Modal,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import { Button} from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { BrowserRouter as Router, Link } from "react-router-dom";
import { UserdashboardRoutes } from "../../../routes/routes";
import DashboardIcon from "@material-ui/icons/Dashboard";
import DateRangeIcon from "@material-ui/icons/DateRange";
import PersonIcon from "@material-ui/icons/Person";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import FileCopyIcon from '@material-ui/icons/FileCopy';
import DescriptionIcon from '@material-ui/icons/Description';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import ReceiptIcon from '@material-ui/icons/Receipt';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import GavelIcon from '@material-ui/icons/Gavel';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChild, faMale, faCopy, faCreditCard, faHandshake, faUserSlash, faFileContract, faGavel, faHeartBroken } from '@fortawesome/free-solid-svg-icons';
import Icon from "@material-ui/core/Icon";
import "./Footer.css";
import Tooltip from '@material-ui/core/Tooltip';
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import SwapHorizRoundedIcon from '@material-ui/icons/SwapHorizRounded';
import { isEmpty } from "lodash";

import {changePassword} from "../accounts/account.actions";

import image from "../../images/pexels5.jpg";

 //'User Grouping'

function UserResponsiveDrawer(props) {

  
  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
    },
    paper: {
       backgroundImage: `url(${image})`,
       backgroundRepeat: "no-repeat",
       backgroundSize: "cover",
    },
    drawer: {
      [theme.breakpoints.up("sm")]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        
  
        marginLeft: drawerWidth,
      },
      backgroundImage: "linear-gradient(to right, rgb(217 216 216) , rgb(217 216 216))",
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuButton1: {
      [theme.breakpoints.up("sm")]: {
        display: "flex",
      },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
      width: drawerWidth,
      color: "blue",
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
  }));
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 400,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);  


const ITEM_HEIGHT = 48;

const drawerWidth = 270;
const drawerList = 
localStorage.getItem("up") == '1' || localStorage.getItem("up") == '3' ? [
        { name: "Introduction", tootltipData:'Introduction Of the Application and Details About Application How To Use It.' },
        { name: "User's Information",tootltipData:'This Will Help You To Fill Petitioner,Respondent and Child Information',
         children: [
           { name:"Profile Information", to:"/User's Information",tootltipData:'This Will Help You To Fill Petitioner and Respondent Information', icon:<FontAwesomeIcon  style={{fontSize:"25px", marginRight:"34px"}} icon={faMale} />},
           { name: "Child Information" , to:"/Child Information",tootltipData:'This Will Help You To Fill Children Information', icon:<FontAwesomeIcon  style={{fontSize:"25px", marginRight:"25px"}} icon={faChild} />}
         ] },
        {
          name: "Step 1: Start a Divorce",
          children: [
            { name: "Petitions Forms", to: "/Step 1: Start a Divorce", tootltipData:'Petitioner', icon:<FileCopyIcon style={{fontSize:"20px", marginRight:"25px"}}></FileCopyIcon>  },
            { name: "Petitions Proof of Service", to: "/ServingCourtForm" , tootltipData:'Serving Court Form Petitioner', icon:<DescriptionIcon style={{fontSize:"20px", marginRight:"25px"}}></DescriptionIcon>},
            { name: "Response Forms", to: "/140" , tootltipData:'Respondant' , icon:<InsertDriveFileIcon style={{fontSize:"20px", marginRight:"25px"}}></InsertDriveFileIcon> },
            { name: "Respondent's Proof of Service", to: "/ServingCourtForm/Respondent" , tootltipData:'Serving Court Form Respondant', icon:<FontAwesomeIcon  style={{fontSize:"18px", marginRight:"25px"}} icon={faCopy} />},
          ],
           tootltipData: 'These questions will help you fill out the following forms: FL-100, FL-110, FL-105, FL-105(a).',
        }] : 


[
  { name: "Introduction", tootltipData:'Introduction Of the Application and Details About Application How To Use It.' },
  { name: "User's Information",tootltipData:'This Will Help You To Fill Petitioner,Respondent and Child Information',
   children: [
     { name:"Profile Information", to:"/User's Information",tootltipData:'This Will Help You To Fill Petitioner and Respondent Information', icon:<FontAwesomeIcon  style={{fontSize:"25px", marginRight:"34px"}} icon={faMale} />},
     { name: "Child Information" , to:"/Child Information",tootltipData:'This Will Help You To Fill Children Information', icon:<FontAwesomeIcon  style={{fontSize:"25px", marginRight:"25px"}} icon={faChild} /> }
   ] },
  {
    name: "Step 1: Start a Divorce",
    children: [
      { name: "Petition Forms", to: "/Step 1: Start a Divorce", tootltipData:'This Will Help You To Fill FL-100, FL-105, FL-105(a),FL-110', icon:<FileCopyIcon style={{fontSize:"20px", marginRight:"25px"}}></FileCopyIcon> },
      { name: "Petitioner’s Proof of Service", to: "/ServingCourtForm" , tootltipData:'This Will Help You To Fill FL-115,FL-117', icon:<DescriptionIcon style={{fontSize:"20px", marginRight:"25px"}}></DescriptionIcon>},
      { name: "Response Forms", to: "/140" , tootltipData:'This Will Help You To Fill FL-105,FL-105(a),FL-120' , icon:<InsertDriveFileIcon style={{fontSize:"20px", marginRight:"25px"}}></InsertDriveFileIcon> },
      { name: "Respondent's Proof of Service", to: "/ServingCourtForm/Respondent" , tootltipData:'This Will Help You To Fill FL-335', icon:<FontAwesomeIcon  style={{fontSize:"18px", marginRight:"25px"}} icon={faCopy} />},
    ],
     tootltipData:'This Will Help You To Fill FL-100, FL-105, FL-105(a),FL-110,FL-115,FL-117,FL-120,FL-335',
  },
  {
    name: "Step 2: Disclose your Financials",
    children: [
      { name: "Instructions [Read First] ", to: "/Instructions",tootltipData:'Instructions.', icon:<ReceiptIcon style={{fontSize:"20px", marginRight:"25px"}}></ReceiptIcon> },
      { name: "Acknowledgment Form (FL-140/FL-141)", to: "/Acknowledgement Form", tootltipData:'Acknowledgment Form (FL-140/FL-141).', icon:<CheckCircleOutlineIcon style={{fontSize:"20px", marginRight:"25px"}}></CheckCircleOutlineIcon> },
      // { name: "Income & Expense (FL-150)", to: "/disclosure/property/Income&Expense", tootltipData:'Income & Expense (FL-150).', icon:<AccountBalanceIcon style={{fontSize:"20px", marginRight:"25px"}}></AccountBalanceIcon> },
      { name: "Income & Expense Petitioner (FL-150)", to: "/disclosure/property/Income&ExpensePetitioner", tootltipData:'Income & Expense Petitioner (FL-150).', icon:<AccountBalanceIcon style={{fontSize:"20px", marginRight:"25px"}}></AccountBalanceIcon> },
      { name: "Income & Expense Respondent (FL-150)", to: "/disclosure/property/Income&ExpenseRespondent", tootltipData:'Income & Expense Respondent (FL-150).', icon:<AccountBalanceIcon style={{fontSize:"20px", marginRight:"25px"}}></AccountBalanceIcon> },
      { name: "Schedule of Assets & Debts (FL-142)", to: "/disclosure/fl-142", tootltipData:'Schedule of Assets & Debts (FL-142).', icon:<CalendarTodayIcon style={{fontSize:"20px", marginRight:"25px"}}></CalendarTodayIcon> },
      // { name: "Property Declaration (FL-160, Community)", to: "/disclosure/property/community-property", tootltipData:'Property Declaration (FL-160, Community).', icon:<CreditCardIcon style={{fontSize:"20px", marginRight:"25px"}}></CreditCardIcon> },
      // { name: "Property Declaration (FL-160, Separate)", to: "/separate-property", tootltipData:'Property Declaration (FL-160, Separate).', icon:<FontAwesomeIcon  style={{fontSize:"16px", marginRight:"25px"}} icon={faCreditCard} /> },
      

    ],
    tootltipData:'These questions will help you fill out the following forms: FL-140,FL-141,142,FL-144,150,160'
  },
  { name: "Step 3: Negotiate an Agreement", to :"/Step 3: Negotiate an Agreement",tootltipData: "Negotiate an Agreement",
  },
  { name: "Step 4: Complete Divorce Judgment", 
  children: [
    {name: "Judgment Packet Forms", to: "/judgment_packet_forms",tootltipData:'Judgment Packet Forms.', icon:<GavelIcon style={{fontSize:"20px", marginRight:"25px"}}></GavelIcon>},
    {name: "Guideline Child Support Form", to: "/child_support_information",tootltipData:'Child Support Information.', icon:<HowToRegIcon style={{fontSize:"20px", marginRight:"25px"}}></HowToRegIcon>},
    {name: "Non-Guideline Child Support", to: "/non_guideline_child_support",tootltipData:'Non GuideLine Child Support.', icon:<FontAwesomeIcon  style={{fontSize:"16px", marginRight:"25px"}} icon={faUserSlash} />},
    { name: "Marital Settlement Agreement", to: "/marital_settlement",tootltipData:'Marital Settlement Agreement.', icon:<FontAwesomeIcon  style={{fontSize:"16px", marginRight:"25px"}} icon={faHandshake} />}
  ],
  tootltipData:'These questions will help you fill out the following forms: Judgment Packet Forms: FL-130,FL-130(a),FL-144,FL-170,FL-180,FL-190 & Guideline Child Support Form: FL-342 & Non-Guideline Child Support: FL-342(a) & MSA.'
 }
];


  const [anchorEl, setAnchorEl] = React.useState(null);
  const [show, setShow] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [showPassword, setShowPassword] = React.useState(false);
  const handleTogglePassword = () => setShowPassword(showPassword => !showPassword);

  const [showPasswordNew, setShowPasswordNew] = React.useState(false);
  const handleTogglePasswordNew = () => setShowPasswordNew(showPasswordNew => !showPasswordNew);


  const handleShow = () => setShow(true);
  const handleCloseModal = () => setShow(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const passwordChange = () => {
    props.changePassword({
      email : localStorage.getItem("current_user_username"),
      oldPassword : currentPassword,
      newPassword : newPassword,
    })
  };

  const error = () => {
    if(props.wrongPassword === false){
      setShow(true)
    }
    else{
      setShow(false)
      
  }
};

  const namesArray = [ "Step 1: Start a Divorce" , "Step 2: Disclose your Financials","Step 3: Negotiate an Agreement","Step 4: Complete Divorce Judgment","Step 5:Marital Settlement Agreement"];

  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const iconSetter = (index) => {
    if (index === 0) {
      return <DashboardIcon style={{ color: "#498ab5" }} />;
    } else if (index === 1) {
      return <SupervisorAccountIcon style={{ color: "#498ab5" }} />;
    } else if (index === 2) {
      return <FontAwesomeIcon  style={{color: "#498ab5", fontSize:"20px", marginLeft:"3px"}} icon={faHeartBroken} />
    } else if (index === 3) {
      return <LocalAtmIcon style={{ color: "#498ab5" }} />
    } 
    else if (index === 4) {
      return <FontAwesomeIcon  style={{color: "#498ab5", fontSize:"20px", marginLeft:"3px"}} icon={faFileContract} />
    }
    else {
      return <FontAwesomeIcon  style={{color: "#498ab5", fontSize:"20px", marginLeft:"3px"}} icon={faGavel} />;
    }
  };

  const [expanded, setExpanded] = React.useState("");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const header = (
    <>
    {/* <div style={{ marginLeft: "150px", marginRight: "auto" }}>
      <h3
        style={{
          color: "#498ab5",
          fontSize: "18px",
          fontFamily: "sans-serif",
          marginTop: "10px",
          marginLeft: "20px",
          marginBottom: "0px",
          fontWeight: "bold",
          inlineSize: "max-content",
          overflow: "hidden",
        }}
      >
        <span>
          Packege: {localStorage.getItem("up") == '1' ? "Trial" : localStorage.getItem("up") == '2' ? "Premium" : localStorage.getItem("up") == '3' ? "Free" : "Closed"} 
        </span>
      </h3>
    </div> */}
    <div className={classes.appBar}>
      <div class="dropdown" style={{display: "inline-flex", alignItems: "center", marginLeft: "auto", marginRight: "auto", float: "right"}}>
        {localStorage.getItem("up") != '2'&& 
        <div style={{backgroundColor: '#92d4ff', borderRadius: "10px", justifyContent: "center"}}>
          <Button href="https://thecompletedivorce.thrivecart.com/complete-plan-upgrade/" target="_blank">
            Upgrade
          </Button>
        </div>
        }
      <div>
      <IconButton
      style={{float:"right"}}
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>

      
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClick={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}
      >
        <Link to="/Landing-Page" style={{color:"black", textDecoration:"none"}}>
        <MenuItem>Landing Page</MenuItem>
            </Link>

        <MenuItem onClick={handleShow} style={{color:"black"}}>Change Password</MenuItem>

        <Link to="/Logout" style={{color:"black", textDecoration:"none"}} onClick={ () => {localStorage.clear();}}>
        <MenuItem >
               Logout
       </MenuItem>
        </Link>
      </Menu>
    </div>
  
</div>
    </div>
    </>
  );

  const drawer = (
    <div>
      <div className={classes.toolbar} style={{ width: "100px"}} />
      <div style={{ textAlign: "center" }}>
        <object
        style={{zIndex:"-1"}}
          data="tcd old logo.svg"
          >
       
        </object>
      </div>
      <List>
        {drawerList.map((text, index) =>
          (!isEmpty(text.children) ) ? (
            <>
              <Accordion
                style={{
                  backgroundColor:"transparent",
                  marginLeft: "-17px",
                  marginTop: "3px",
                  marginBottom: "0px",
                  // pointerEvents: props.isFilled === 0 && namesArray.includes(text.name)? 'none':'auto',
                  // pointerEvents:'auto',
                }}
                onChange={handleChange(index)}
                expanded={expanded === index}
                key={`${index}_${text.name}`}
              >
                 <HtmlTooltip 
        title={
          <React.Fragment>
            <Typography color="inherit">{text.tootltipData}</Typography>
          </React.Fragment>
        }
      >
                <AccordionSummary style={{ height: "20px"}}>
                  <ListItem
                    button
                    key={text}
                    style={{
                      color: "#498ab5",
                      backgroundColor:"transparent"
                    }}
                    component={Link}
                  >
                    <ListItemIcon>{iconSetter(index)}</ListItemIcon>
                    <ListItemText primary={text.name} />
                  </ListItem>
                </AccordionSummary>
                </HtmlTooltip>
                {/* Inside Accordion*/}

                {text.children.map((childText, childIndex) => (
                  <AccordionDetails
                    style={{
                      borderBottom: "1px solid skyblue",
                      borderTop: "1px solid skyblue",
                      
                    }}
                  >
                   <HtmlTooltip
        title={
          <React.Fragment>
            <Typography color="inherit">{childText.tootltipData}</Typography>
          </React.Fragment>
        }
      >
                    <Typography style={{ paddingTop: "10px" }}>
                      <Link
                        style={{
                          color: "#498ab5",
                          textDecoration: "none",
                          marginLeft: "70px",
                        }}
                        to={childText.to}
                      >
                        <span>{childText.icon}</span>
                         
                        {childText.name}
                      </Link>
                    </Typography>
                    </HtmlTooltip>
                  </AccordionDetails>
                ))}
              </Accordion>
            </>
          ) : (
            <>
              <HtmlTooltip
        title={
          <React.Fragment>
            <Typography color="inherit">{text.tootltipData}</Typography>
          </React.Fragment>
        }
      >
              <ListItem
                button
              key={`${index}_${text.name}`}
                style={{
                  color: "#498ab5",
                  marginTop: "3px",
               //   pointerEvents: props.isFilled === 0  && namesArray.includes(text.name)? 'none':'auto',
                //  pointerEvents: 'auto',
                }}
                component={Link}
                to={"/" + text.name}
              >
                <ListItemIcon>{iconSetter(index)}</ListItemIcon>
                <ListItemText primary={text.name} />
              </ListItem>
              </HtmlTooltip>
            </>
          )
        )}
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;
    

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
      
        <Toolbar>
        {header}
          <h3 className={classes.menuButton1} style={{ color: "#00BBBB" }}>
            {}
          </h3>
          <IconButton
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Router>
        
        <nav className={classes.drawer} aria-label="mailbox folders">
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Hidden smUp implementation="css">
            
            <Drawer
              container={container}
              variant="temporary"
              anchor={theme.direction === "rtl" ? "right" : "left"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
            >          
              {drawer}
            </Drawer>
            
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer 
              classes={{
                paper: classes.paper,
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
            
          </Hidden>
          
        </nav>
        <main
          className={classes.content}
          style={{
            top: "0",
            width: "100%",
            height: "100%",
            backgroundSize: "cover",
            opacity: "100%",
            marginLeft: "170px",
            paddingLeft: '75px',
            paddingRight: '75px',
             alignItems: 'center'
          }}
          
        >
          
          
          <div className={classes.toolbar}  />
          
 
          {UserdashboardRoutes}
          
        </main>
      </Router>
      <Modal isOpen={show} style={{ marginTop: "150px", marginLeft: "46%" }}>
        <ModalHeader>
          Change Your Password
          <CloseIcon style={{}} onClick={handleCloseModal}></CloseIcon>
        </ModalHeader>
        <ModalBody>
             {props.wrongPassword === true &&  <Alert style={{width:"250px"}} variant="filled" severity="error">
               Current Password is Wrong </Alert>} 
          <div style={{display:"flex", flexDirection:"column", marginTop:"20px"}}>

          <TextField id="standard-basic" label="Current Password"  type={showPassword ? 'text' : 'password'}
          onBlur={(e) => setCurrentPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                  <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleTogglePassword}
                >
                  {showPassword ? <VisibilityIcon style={{color: '#00BBBB'}}/> : <VisibilityOffIcon style={{color: '#00BBBB'}}/>}
                </IconButton>
              </InputAdornment>
              ),
          }}/>

          <TextField id="standard-basic" style={{marginTop:"10px"}} label="New Password"  type={showPasswordNew ? 'text' : 'password'}
          onBlur={(e) => setNewPassword(e.target.value)} 
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                  <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleTogglePasswordNew}
                >
                  {showPasswordNew ? <VisibilityIcon style={{color: '#00BBBB'}}/> : <VisibilityOffIcon style={{color: '#00BBBB'}}/>}
                </IconButton>
              </InputAdornment>
              ),
          }} />

        
          </div>
        </ModalBody>
       
        <ModalFooter>
        <Button variant="outlined" onClick={()=> {passwordChange(); error()}}>Change Password</Button>
        </ModalFooter>
 
      </Modal>
    </div>
  );
  
}

UserResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => {
  return {
    changePassword: (data) => dispatch(changePassword(data)),
  };
};

const mapStateToProps = (state, ownProps) => ({
 
  isFilled: state.userAccountReducer.isFilled,
  wrongPassword: state.userAccountReducer.wrongPassword,
  userPackage : state.userAccountReducer.userPackage,
});


export default connect(mapStateToProps,mapDispatchToProps)(UserResponsiveDrawer);
